import styled from '@emotion/styled';
import {CommandBar, Dialog} from '@bosch/react-frok';

export const DialogWrapper = styled(Dialog, {
    shouldForwardProp: (props) => props !== 'headlineSpace'
})<{ headlineSpace: boolean }>`
    & .m-dialog__headline {
        margin-right: ${(props) => (props.headlineSpace ? '8rem' : 0)};
        word-wrap: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const PreviewWrapper = styled.div`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export const FileImages = styled.img`
    justify-content: center;
    text-align: center;
    align-self: center;
    max-height: 100%;
    max-width: 100%;
`;

export const ActionBar = styled(CommandBar)`
    margin-top: -4rem;
    background-color: white;
    &&& {
        padding: 0px;
    }
`;
